import { createSwatch } from '@clover-css/swatch';

/**
 * color definitions
 * @see https://www.figma.com/file/muqmj4npaceugvwqntuhnd/foundation?node-id=1%3a51
 */

export const green = createSwatch('#228800', {
  background: '#f2fcee',
  unknownLight: '#83c575',
  accent: '#43b02a',
  dark: '#246615',
});

export { green as brand };

export const blue = createSwatch('#3271ab', {
  lightBackground: '#e6f3ff',
  darkBackground: '#253338',
  background: '#e6f3ff',
  unknownLight: '#7bbaf5',
  accent: '#339dff',
  dark: '#285a88',
  textLink: '#1177cc',
  darkTextLink: '#0764ab',
  extraDarkText: '#212C31',
});

export const teal = createSwatch('#14818d', {
  background: '#eefbfc',
  accent: '#69d0dd',
  dark: '#286271',
});

export const eggplant = createSwatch('#faf3fd', {
  background: '#faf3fd',
  accent: '#9966cc',
  dark: '#5b3e77',
});

export const red = createSwatch('#e70000', {
  background: '#ffeded',
  dark: '#c60000',
  glow: [225,53,69,.25],
});

export const yellow = createSwatch('#ffd100', {
  background: '#fff6cc',
});

export const gray = createSwatch('#727272', {
  button: '#F0F0F0',
  buttonHover: '#D2D2D2',
  background: '#fbfbfb',
  light: '#e5e5e5',
  disabled: '#c7c7c7',
  dark: '#5c5c5c',
  lighter: '#727272',
});

// alias
export { gray as grey };

export const black = createSwatch('#000');

// alias
export { black as text };

export const white = createSwatch('#fff');
